function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.4 43.62c15.9 15.9 29.87 18 35.47 18.35A41 41 0 0062 48.51a50.9 50.9 0 00-14.68-9.79l-6.12 6.12c-2.09-.56-6.6-1.71-13.45-8.56s-8-11.37-8.56-13.45l6.12-6.12A50.91 50.91 0 0015.51 2 41 41 0 002.05 8.15c.31 5.61 2.45 19.57 18.35 35.47z",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 3.46
});

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+cGhvbmU8L3RpdGxlPjxwYXRoIGQ9Ik0yMC40LDQzLjYyYzE1LjksMTUuOSwyOS44NywxOCwzNS40NywxOC4zNUE0MSw0MSwwLDAsMCw2Miw0OC41MWE1MC45LDUwLjksMCwwLDAtMTQuNjgtOS43OWwtNi4xMiw2LjEyYy0yLjA5LS41Ni02LjYtMS43MS0xMy40NS04LjU2cy04LTExLjM3LTguNTYtMTMuNDVsNi4xMi02LjEyQTUwLjkxLDUwLjkxLDAsMCwwLDE1LjUxLDIsNDEsNDEsMCwwLDAsMi4wNSw4LjE1QzIuMzYsMTMuNzYsNC41LDI3LjcyLDIwLjQsNDMuNjJaIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjMuNDYiLz48L3N2Zz4=";
export { SvgPhone as ReactComponent };